/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Score_Ease_Of_UseInputs */

const en_directory_score_ease_of_use = /** @type {(inputs: Directory_Score_Ease_Of_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ease of use`)
};

const zh_directory_score_ease_of_use = /** @type {(inputs: Directory_Score_Ease_Of_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`易用性`)
};

/**
* | output |
* | --- |
* | "Ease of use" |
*
* @param {Directory_Score_Ease_Of_UseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_score_ease_of_use = /** @type {((inputs?: Directory_Score_Ease_Of_UseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Score_Ease_Of_UseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_score_ease_of_use(inputs)
	return zh_directory_score_ease_of_use(inputs)
});
export { directory_score_ease_of_use as "directory.score.ease_of_use" }